import { useTranslation } from "react-i18next"
import { DocumentLinkButton } from "@/components/chat/DocumentLinkButton"
import type { OrderDocument } from "@/components/chat/useOrderDocuments"

const KIND_LABEL_KEYS = {
  order: "chat.orderDocuments.order",
  cmr: "chat.orderDocuments.cmr",
} as const satisfies Record<OrderDocument["kind"], string>

export const OrderDocumentList = ({
  documents,
  onOpen,
}: {
  documents: OrderDocument[]
  onOpen?: (document: OrderDocument) => void
}) => {
  const { t } = useTranslation()
  return (
    <ul className="space-y-1.5">
      {documents.map((document) => (
        <li key={`${document.kind}-${document.url}`}>
          <DocumentLinkButton
            label={document.fileName}
            onClick={() => onOpen?.(document)}
            data-testid="driver-overview-document"
            data-kind={document.kind}
            trailing={
              <span className="shrink-0 text-xs text-muted-foreground">
                {t(KIND_LABEL_KEYS[document.kind])}
              </span>
            }
          />
        </li>
      ))}
    </ul>
  )
}

export default OrderDocumentList
